import { useEffect, useRef } from 'react';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const useBodyScrollLock = (trigger) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current === null) {
            clearAllBodyScrollLocks();
            return;
        }
        if (trigger === true) {
            disableBodyScroll(ref.current);
        }
        else {
            enableBodyScroll(ref.current);
        }
        return () => {
            if (ref.current !== null) {
                enableBodyScroll(ref.current);
            }
        };
    }, [trigger]);
    return ref;
};
export default useBodyScrollLock;
